import { mapGetters } from 'vuex'

import { measureMixin, modalMixin } from 'mixins'

export default {
  mixins: [measureMixin, modalMixin],
  data() {
    return {
      addresses: [],
    }
  },
  props: {
    tender: {
      type: Object,
      required: true
    },
    group: {
      type: Object,
      required: true
    },
    in_creating: {
      type: Boolean,
      default: false
    },
    disableOpenOffersForLot: {
      type: Boolean,
      default: false
    },
    lots_headers: {
      type: Array,
      required: true
    },
    customSortSlice: {
      type: Function,
      required: true
    },
    bidding_type: {
      type: Object,
      required: true
    },
    additional_fields: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      $_tendersSettings: 'getTendersSettings',
    }),
  },
  methods: {    
    /**
     * Получение заголовка адреса
     */
    $_getAddressTitle(id) {
      return this.addresses?.find(el => id == el.supplierAddressId)?.title || this.geFulltAddress(id)
    },
    /**
     * Получение полного адреса
     */
    $_geFulltAddress(id) {
      let address = this.addresses?.find(el => id == el.supplierAddressId)
      if (address) {
        return (address.postalCode || '') + ' ' + this.$t('Common.City') + ' ' + address.city + ' ' + address.street
      } else {
        return id
      }
    },
    formatField(field, lotId) {
      let type = field?.typeId || field?.type?.typeId
      let value = field.fieldValues.find(values => values.entityKey == lotId)?.value
      let formatted = ''
      if ( type == 'DATE_TIME' ) {
        formatted = this.formatBy(value, 'DD.MM.YYYY')
      } else if (type == 'CHECKBOX') {
        formatted = eval(value) ? this.$t('Tenders.Yes') : this.$t('Tenders.No')
      } else {
        formatted =  value
      }
      return formatted
    },
  },
  mounted() {
    if ( this.lots_headers.some(el => el.value == 'addressId') ) {
      this.$store.dispatch('setSupplierAddress')
        .then(res => this.addresses = res)
    }
  },
}